export const environment = {
  production: true,
  version: '10.4.18.0',
  paypalSandbox: false,
  SWAapiEnvMode: 'prod'
};
